import { notification } from 'antd'
import { Form } from 'formsy-semantic-ui-react'
import * as R from 'ramda'
import React from 'react'
import { Button, Label, TextArea } from 'semantic-ui-react'
import styled from 'styled-components'
import { postRun } from '../api/async/index'
import { getPaidParticipants } from '../api/async/participants/index'
import { getBase64, isLogin } from '../utils'
import { endSubmitRun, generateOption, startSubmitRun } from '../utils/index'
import Login from './Login'
import Signup from './Signup'

const StyledSelect = styled(Form.Select)`
  @media only screen and (min-device-width: 320px) and (max-device-width: 480px) {
    width: 100%;
    margin-bottom: 10px;
  }
`

const StyledField = styled(Form.Field)`
  @media only screen and (min-device-width: 320px) and (max-device-width: 480px) {
    width: 100%;
    margin-bottom: 10px;
  }
`

class SubmitRun extends React.Component {
  state = {
    participantOption: [],
    showLogin: !isLogin(),
    showSignup: false,
    loading: false,
    is_walk: false
  }

  componentDidMount = async () => {
    getPaidParticipants().then(res => {
      const options = res.data
        .filter(this.filterStartDate)
        .filter(this.filterEndSubmitRun)
        .filter(this.filterNotCollectDistance)
        .map(this.generateParticipantOption)
      this.setState({ participantOption: options })
    })
    document.title = 'Run24Hrs - แจ้งผลวิ่ง / เดิน'
  }

  filterStartDate = participant =>
    startSubmitRun(R.path(['race_detail', 'race'], participant))

  filterEndSubmitRun = participant =>
    !endSubmitRun(R.path(['race_detail', 'race'], participant))

  filterNotCollectDistance = participant =>
    !(
      !R.path(['race_detail', 'race', 'collect_distance'], participant) &&
      participant.finish_run
    )

  generateParticipantOption = participant => ({
    key: participant.id,
    text: `${participant.race_detail.race.title} - ${
      participant.race_detail.distance.name
    }`,
    value: participant.id,
    is_walk: participant.race_detail.race.is_walk
  })

  handleChange = (e, { name, value }) => {
    this.setState({ [name]: value })
    if (name === 'participant') {
      const { is_walk } = this.state.participantOption.find(
        each => each.key === value
      )
      this.setState({ is_walk })
    }
  }

  handleFile = e => {
    getBase64(e.target.files[0]).then(data => this.setState({ image: data }))
  }

  handleFile2 = e => {
    getBase64(e.target.files[0]).then(data => this.setState({ image2: data }))
  }
  handleFile3 = e => {
    getBase64(e.target.files[0]).then(data => this.setState({ image3: data }))
  }
  handleFile4 = e => {
    getBase64(e.target.files[0]).then(data => this.setState({ image4: data }))
  }
  handleFile5 = e => {
    getBase64(e.target.files[0]).then(data => this.setState({ image5: data }))
  }

  handleSubmit = () => {
    const {
      image,
      image2,
      image3,
      image4,
      image5,
      participant,
      distance,
      hour,
      minute,
      second,
      note
    } = this.state
    const actualHour = hour <= 0 ? 0 : hour
    const actualMinute = minute <= 0 ? 0 : minute
    const actualSecond = second <= 0 ? 0 : second
    const time = parseFloat(
      `${(actualHour * 60 || 0) + actualMinute}.${
        actualSecond < 10 ? `0${actualSecond}` : actualSecond
      }`
    )
    this.setState({ loading: true })
    postRun({
      image,
      image2,
      image3,
      image4,
      image5,
      participant,
      distance: parseFloat(distance).toFixed(2),
      time,
      note
    }).then(() => {
      notification.success({ message: 'ส่งผลการวิ่งสำเร็จแล้ว' })
      this.setState({ loading: false })
      this.props.history.push('/run-status')
    })
  }

  render() {
    const errorLeftLabel = <Label color="red" pointing="left" />
    const errorLabel = <Label color="red" pointing />
    const hourOptions = generateOption(
      Array(24)
        .fill(0)
        .map((e, i) => i)
    )
    hourOptions[0].value = -1
    const minuteAndSecondOptions = generateOption(
      Array(60)
        .fill(0)
        .map((e, i) => i)
    )
    minuteAndSecondOptions[0].value = -1
    return (
      <React.Fragment>
        <h1>แจ้งผลการวิ่ง / เดิน</h1>
        <p>(รูปผลการวิ่ง ควรมีระยะทางเเละระยะเวลาที่ชัดเจน)</p>
        <Form
          onValidSubmit={this.handleSubmit}
          style={{ marginBottom: '10px' }}
        >
          <Form.Group className="mb10">
            <StyledField>
              <label>รายการวิ่ง / เดิน: </label>
              <StyledSelect
                required
                name="participant"
                value={this.state.participant}
                options={this.state.participantOption}
                placeholder="เลือกรายการวิ่ง / เดิน"
                onChange={this.handleChange}
              />
            </StyledField>
          </Form.Group>
          {!this.state.is_walk && (
            <React.Fragment>
              <div className="inline field" style={{ marginTop: -7 }}>
                <label>เวลาที่ใช้วิ่ง: </label>
              </div>
              <Form.Group style={{ marginTop: -15 }}>
                <StyledSelect
                  name="hour"
                  value={this.state.hour}
                  options={hourOptions}
                  placeholder="ชั่วโมง"
                  onChange={this.handleChange}
                />
                <StyledSelect
                  required
                  name="minute"
                  value={this.state.minute}
                  options={minuteAndSecondOptions}
                  placeholder="นาที"
                  onChange={this.handleChange}
                />
                <StyledSelect
                  name="second"
                  options={minuteAndSecondOptions}
                  value={this.state.second}
                  placeholder="วินาที"
                  onChange={this.handleChange}
                />
              </Form.Group>
            </React.Fragment>
          )}
          <Form.Group>
            <StyledField>
              <label>ระยะทาง / ก้าวเดิน: </label>
              <Form.Input
                required
                validations="isNumeric"
                validationErrors={{
                  isDefaultRequiredValue: this.state.is_walk
                    ? 'โปรดระบุจำนวนก้าวเดิน'
                    : 'โปรดระบุระยะทางที่วิ่งในหน่วยกิโลเมตร',
                  isNumeric: `โปรดใส่เฉพาะตัวเลข ตัวอย่างเช่น 5.28`
                }}
                name="distance"
                placeholder={
                  this.state.is_walk
                    ? 'จำนวนก้าวเดิน'
                    : 'ระยะทางที่วิ่ง (กิโลเมตร)'
                }
                onChange={this.handleChange}
                errorLabel={errorLabel}
              />
            </StyledField>
          </Form.Group>
          <Form.Group className="mt10">
            <label className="ui button mb10 ml10" htmlFor="image-upload">
              *แนบผลการวิ่ง/เดิน
            </label>
            <Form.Input
              required
              errorLabel={errorLeftLabel}
              validationErrors={{
                isDefaultRequiredValue: 'กรุณาแนบหลักฐานการวิ่ง / เดิน'
              }}
              style={{ display: 'none' }}
              id="image-upload"
              name="image"
              type="file"
              iconPosition="left"
              onChange={this.handleFile}
            />
          </Form.Group>
          {this.state.image && (
            <img className="ui large image mb10" src={this.state.image} />
          )}
          {this.state.image && (
            <React.Fragment>
              <Form.Group className="mt10">
                <label className="ui button mb10 ml10" htmlFor="image-upload2">
                  แนบผลการวิ่ง (เพิ่มเติม)
                </label>
                <Form.Input
                  style={{ display: 'none' }}
                  id="image-upload2"
                  name="image"
                  type="file"
                  iconPosition="left"
                  onChange={this.handleFile2}
                />
              </Form.Group>
              {this.state.image2 && (
                <img className="ui large image mb10" src={this.state.image2} />
              )}
            </React.Fragment>
          )}
          {this.state.image2 && (
            <React.Fragment>
              <Form.Group className="mt10">
                <label className="ui button mb10 ml10" htmlFor="image-upload3">
                  แนบผลการวิ่ง (เพิ่มเติม)
                </label>
                <Form.Input
                  style={{ display: 'none' }}
                  id="image-upload3"
                  name="image"
                  type="file"
                  iconPosition="left"
                  onChange={this.handleFile3}
                />
              </Form.Group>
              {this.state.image3 && (
                <img className="ui large image mb10" src={this.state.image3} />
              )}
            </React.Fragment>
          )}
          {this.state.image3 && (
            <React.Fragment>
              <Form.Group className="mt10">
                <label className="ui button mb10 ml10" htmlFor="image-upload4">
                  แนบผลการวิ่ง (เพิ่มเติม)
                </label>
                <Form.Input
                  style={{ display: 'none' }}
                  id="image-upload4"
                  name="image"
                  type="file"
                  iconPosition="left"
                  onChange={this.handleFile4}
                />
              </Form.Group>
              {this.state.image4 && (
                <img className="ui large image mb10" src={this.state.image4} />
              )}
            </React.Fragment>
          )}
          {this.state.image4 && (
            <React.Fragment>
              <Form.Group className="mt10">
                <label className="ui button mb10 ml10" htmlFor="image-upload5">
                  แนบผลการวิ่ง (เพิ่มเติม)
                </label>
                <Form.Input
                  style={{ display: 'none' }}
                  id="image-upload5"
                  name="image"
                  type="file"
                  iconPosition="left"
                  onChange={this.handleFile5}
                />
              </Form.Group>
              {this.state.image5 && (
                <img className="ui large image mb10" src={this.state.image5} />
              )}
            </React.Fragment>
          )}
          <Form.Group
            style={{
              marginTop: '10px',
              marginBottom: '10px',
              marginLeft: '3px'
            }}
          >
            <TextArea
              name="note"
              style={{ width: '225px' }}
              placeholder="รายละเอียดเพิ่มเติม&#10;(เว้นว่างได้)"
              onChange={e => this.setState({ note: e.target.value })}
              value={this.state.note}
            />
          </Form.Group>
          <Button
            className="ui teal"
            type="submit"
            {...this.state.loading && { loading: true, disabled: true }}
          >
            แจ้งผลการวิ่ง / เดิน
          </Button>
        </Form>
        <Login
          open={this.state.showLogin}
          onClose={() => this.setState({ showLogin: false })}
          closeOnDimmerClick={false}
          closeOnEscape={false}
          toggleSignup={() => {
            this.setState({ showLogin: false })
            this.setState({ showSignup: true })
          }}
        />
        <Signup
          open={this.state.showSignup}
          onClose={() => this.setState({ showSignup: false })}
        />
      </React.Fragment>
    )
  }
}

export default SubmitRun



// WEBPACK FOOTER //
// /opt/build/repo/src/containers/SubmitRun.js